
import { i18nText } from '@/locales';
import { LoyaltyCertAddRequestType } from '@/form/loyalty/loyaltyCert/LoyaltyCert.types';

export class LoyaltyCertFormData {
    public id?: number | null;
    public type_id: number | null;
    public client_id: number | null;
    public salon_id?: number | null;
    public cashbox_id: number | null;
    public cashbox_sum: number;
    public code: string;
    public proceed_payment: boolean;

    setFormData(data: LoyaltyCertAddRequestType): void {
        this.id = data.id;
        this.type_id = data.type;
        this.client_id = data.client_id;
        this.salon_id = data.salon_id;
        this.cashbox_id = data.cashbox_id;
        this.cashbox_sum = data.cashbox_sum;
        this.code = data.code;
        this.proceed_payment = data.proceed_payment;
    }
    constructor() {
        this.type_id = null;
        this.client_id = null;
        this.salon_id = null;
        this.cashbox_id = null;
        this.cashbox_sum = 0;
        this.proceed_payment = true;
        this.code = Math.floor(10000000 + Math.random() * 90000000).toString();
    }
}
export const FormRules = {
    type_id: [{ required: true, message: i18nText("Укажите сертификат"), trigger: 'change' }],
    client_id: [{ required: true, message: i18nText("Укажите клиента"), trigger: 'change' }],
    cashbox_id: [{ required: true, message: i18nText("Выберите кассу"), trigger: 'change' }],
    code: [{ required: true }],
};
